var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "view-growers-form",
      attrs: { hide: _vm.loading },
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: _vm.pageTitle, icon: "fa-building" } },
        [
          _vm.growerId
            ? _c(
                "ui-button",
                {
                  attrs: { color: "negative", icon: "magicon-trash" },
                  on: { click: _vm.deleteGrower },
                },
                [_vm._v("Verwijderen")]
              )
            : _vm._e(),
          _c(
            "ui-button",
            {
              attrs: { color: "positive", loading: _vm.submitting },
              on: {
                click: function ($event) {
                  return _vm.$refs.form.submit()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
          _c(
            "ui-button",
            {
              attrs: { slot: "left", color: "medium", type: "bordered" },
              on: {
                click: function ($event) {
                  return _vm.$router.go(-1)
                },
              },
              slot: "left",
            },
            [_vm._v("Annuleren")]
          ),
        ],
        1
      ),
      _c(
        "ui-form-panel",
        {
          ref: "form",
          attrs: { "auto-validate": "" },
          on: { submit: _vm.submit },
        },
        [
          _c("ui-form-input", {
            attrs: {
              title: "E-mail adres",
              name: "email",
              rules: "required|email",
            },
            model: {
              value: _vm.pendingGrower.email,
              callback: function ($$v) {
                _vm.$set(_vm.pendingGrower, "email", $$v)
              },
              expression: "pendingGrower.email",
            },
          }),
          _c("ui-form-input", {
            attrs: { title: "Naam", name: "name", rules: "required" },
            model: {
              value: _vm.pendingGrower.name,
              callback: function ($$v) {
                _vm.$set(_vm.pendingGrower, "name", $$v)
              },
              expression: "pendingGrower.name",
            },
          }),
          _c("ui-form-input", {
            attrs: { title: "Adres", name: "address", rules: "required" },
            model: {
              value: _vm.pendingGrower.address,
              callback: function ($$v) {
                _vm.$set(_vm.pendingGrower, "address", $$v)
              },
              expression: "pendingGrower.address",
            },
          }),
          _c("ui-form-input", {
            attrs: { title: "Postcode", name: "postcode", rules: "required" },
            model: {
              value: _vm.pendingGrower.postcode,
              callback: function ($$v) {
                _vm.$set(_vm.pendingGrower, "postcode", $$v)
              },
              expression: "pendingGrower.postcode",
            },
          }),
          _c("ui-form-input", {
            attrs: {
              title: "Telefoon nr.",
              name: "phoneNumber",
              rules: "required",
            },
            model: {
              value: _vm.pendingGrower.phoneNumber,
              callback: function ($$v) {
                _vm.$set(_vm.pendingGrower, "phoneNumber", $$v)
              },
              expression: "pendingGrower.phoneNumber",
            },
          }),
          _vm.isAdmin
            ? _c("ui-form-radio", {
                attrs: {
                  title: "Water inzichten toegankelijk",
                  name: "waterInsightsAccessible",
                  options: _vm.waterInsightsAccessibleOptions,
                  rules: "required",
                },
                model: {
                  value: _vm.waterInsightsAccessibleValue,
                  callback: function ($$v) {
                    _vm.waterInsightsAccessibleValue = $$v
                  },
                  expression: "waterInsightsAccessibleValue",
                },
              })
            : _vm._e(),
          _vm.isAdmin
            ? _c("ui-form-radio", {
                attrs: {
                  title: "Leveren aan andere kwekers",
                  name: "shared",
                  options: _vm.waterInsightsAccessibleOptions,
                  rules: "required",
                },
                model: {
                  value: _vm.sharedValue,
                  callback: function ($$v) {
                    _vm.sharedValue = $$v
                  },
                  expression: "sharedValue",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }